/*  Some methods for reading in and querying metadata, e.g. data about Onkopus data sources */
/* The according file should be in @/data and called metadata.yml */
import { store } from '@/store';
import metadata from '/data/metadata.json';

export default {

    /**
     * Reads the source file into store.
     */
    async readSourceFile () {
        try {
            store.dispatch('setOnkopusMetadata', metadata);
        }
        catch (e) {
            return;
        }
    },

    /**
     * Returns an object with metadata about a term.
     * @param {String} key - The term to query metadata for
     */
    get (key) {
        return store.getters.get_metadata_for(key);
    },

    /**
     * Clears all metadata from the store.
     */
    clear() {
        store.dispatch('clearOnkopusMetadata');
    }
    
}